import { createSelector } from 'reselect';
import { ROOT_KEY } from './constants';

const searchSelector = createSelector(
    state => state[ROOT_KEY],
    search => search
);

export default searchSelector;
